module.exports = __webpack_public_path__ + "img/logo.ed8313ad.png";